import React from 'react';
import {
	Card, Row, Col, Button, Form, DatePicker, Select, Table, Empty,
	message, Typography, Tooltip,
} from 'antd';
import {
	SearchOutlined, PrinterOutlined, RedoOutlined,
	SyncOutlined, CarOutlined, FileTextOutlined, TeamOutlined,
	CalendarOutlined, WalletOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { connect } from 'react-redux';
import {
	initHandler, ajaxViewHandler, ajaxHandler, setConfig, ajaxDownloadHandler,
} from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import '../../assets/laporan.css';

const { Text } = Typography;
const { MonthPicker } = DatePicker;

const configClass = {
	title: 'Cross Check SWDKLLJ',
	apiUrl: {
		data      : 'transaksi/api/uji-silang/',
		meta      : 'transaksi/api/uji-silang/upt-pilihan/',
		kabupaten : 'master/api/kabupaten/',
		upt       : 'pegawai/api/upt/',
	},
};

const config = new Config();

class UjiSilangSWD extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			loading:          false,
			data:             null,
			err:              false,
			errMsg:           '',
			filterBulan:      null,
			filterKabupaten:  undefined,
			filterUpt:        undefined,
			filter:           '',
			isMobile:         window.innerWidth <= 768,
			kabupatenLocked:  false,
			loadingMeta:      true,
			loadingKabupaten: false,
			loadingUpt:       false,
			listKabupaten:    [],
			listUpt:          [],
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.getMeta();
	}

	getMeta() {
		this.setState({ loadingMeta: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.meta)
			.then(() => {
				if (this.props.isSuccess) {
					const res = this.props.responseMsg;
					if (res.kabupaten_locked) {
						// User biasa: kabupaten terkunci ke kabupaten sendiri,
						// daftar UPT sudah di-scope dari backend
						this.setState({
							kabupatenLocked: true,
							filterKabupaten: res.own_kabupaten_id,
							filterUpt: res.own_upt_id,
							listKabupaten: res.own_kabupaten_id
								? [{ id: res.own_kabupaten_id, name: res.own_kabupaten_nama }]
								: [],
							listUpt: res.upts || [],
						});
					} else {
						// Admin/Superadmin: wajib pilih kabupaten & UPT sendiri
						this.setState({ kabupatenLocked: false });
						this.getListKabupaten();
					}
				}
				this.setState({ loadingMeta: false });
			})
			.catch(() => this.setState({ loadingMeta: false }));
	}

	getListKabupaten() {
		this.setState({ loadingKabupaten: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.kabupaten + '?limit=500')
			.then(() => {
				if (this.props.isSuccess) {
					const res  = this.props.responseMsg;
					const list = res.results || (Array.isArray(res) ? res : []);
					this.setState({ listKabupaten: list });
				}
				this.setState({ loadingKabupaten: false });
			})
			.catch(() => this.setState({ loadingKabupaten: false }));
	}

	getListUpt(kabupatenId) {
		this.setState({ loadingUpt: true, listUpt: [] });
		this.props.ajaxViewHandler('get', configClass.apiUrl.upt + '?kabupaten=' + kabupatenId + '&limit=500')
			.then(() => {
				if (this.props.isSuccess) {
					const res  = this.props.responseMsg;
					const list = res.results || (Array.isArray(res) ? res : []);
					this.setState({ listUpt: list });
				}
				this.setState({ loadingUpt: false });
			})
			.catch(() => this.setState({ loadingUpt: false }));
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	handleSubmit = () => {
		const { filterBulan, filterKabupaten, filterUpt } = this.state;
		if (!filterBulan) {
			message.warning({ content: 'Pilih bulan terlebih dahulu', duration: 2, key: 'toast' });
			return;
		}
		if (!filterKabupaten || !filterUpt) {
			message.warning({ content: 'Kabupaten dan UPT wajib dipilih', duration: 2, key: 'toast' });
			return;
		}
		const filter = `?mulai_dari=${filterBulan.format('MM-YYYY')}&kabupaten=${filterKabupaten}&upt=${filterUpt}`;
		this.setState({ filter });
		this.getData(filter);
	};

	handlePrint = () => {
		const section = document.querySelector('.kertas-laporan');
		if (!section) return;
		const parent  = section.parentNode;
		const nextSib = section.nextSibling;
		// FIX: dulu 'block' - inline style MENIMPA aturan CSS
		// .uji-silang-cetak.kertas-laporan { display: flex } (inline selalu
		// menang atas class), jadi margin-top:auto di footer tidak pernah
		// berfungsi (cuma berlaku utk flex/grid item) - footer selalu jatuh
		// tepat setelah blok tanda tangan, bukan mentok ke dasar halaman
		// (lihat laporan 2026-10-09). '' membiarkan CSS class yang menentukan.
		section.style.display = '';
		document.body.appendChild(section);
		const siblings = Array.from(document.body.children).filter(el => el !== section);
		siblings.forEach(el => { el.style.display = 'none'; });
		window.print();
		siblings.forEach(el => { el.style.display = ''; });
		section.style.display = 'none';
		if (nextSib) parent.insertBefore(section, nextSib);
		else parent.appendChild(section);
	}

	async getData(filter) {
		message.loading({ content: 'Menampilkan laporan...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data: this.props.responseMsg, err: false });
				} else {
					this.setState({ loading: false, data: null, err: true, errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false, data: null, err: true, errMsg: 'Gagal koneksi' });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	render() {
		const {
			loading, data, err, filterBulan, filterKabupaten, filterUpt,
			kabupatenLocked, listKabupaten, loadingKabupaten, listUpt, loadingUpt,
			isMobile,
		} = this.state;
		const belumLengkap = !filterBulan || !filterKabupaten || !filterUpt;
		const isEmpty = data && (!data.summary || !data.summary.total_sw);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.uji-silang-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 12px; }
						.uji-silang-wrap .ant-picker { border-radius: 8px !important; }

						.uji-stat-card {
							border-radius: 12px;
							padding: 14px 16px;
							height: 100%;
							display: flex;
							align-items: center;
							gap: 12px;
							box-shadow: 0 2px 10px rgba(15,40,71,0.06);
							border: 1px solid #eef1f6;
							background: #fff;
						}
						.uji-stat-icon {
							width: 40px; height: 40px; border-radius: 10px;
							display: flex; align-items: center; justify-content: center;
							font-size: 18px; color: #fff; flex-shrink: 0;
						}
						.uji-stat-label { font-size: 11.5px; color: #8a94a6; font-weight: 600; text-transform: uppercase; letter-spacing: .3px; }
						.uji-stat-value { font-size: 17px; font-weight: 700; color: #0f2847; margin-top: 2px; }

						.uji-preview-table .ant-table-thead > tr > th {
							background: #f4f7fb; color: #374151; font-weight: 700; font-size: 12.5px;
						}
						.uji-preview-table .ant-table-tbody > tr > td { font-size: 13px; }
						.uji-preview-table .ant-table-tbody > tr:hover > td { background: #f8fafc; }

						.uji-mobile-row {
							display: flex; justify-content: space-between; align-items: center;
							padding: 10px 14px; border-radius: 10px; border: 1px solid #eef1f6;
							background: #fff; margin-bottom: 8px;
						}

						.uji-ttd-card {
							border: 1px solid #eef1f6; border-radius: 12px; padding: 16px;
							text-align: center; background: #fafbfd; height: 100%;
						}
						.uji-ttd-jabatan { font-size: 12px; color: #8a94a6; font-weight: 600; text-transform: uppercase; letter-spacing: .3px; }
						.uji-ttd-nama { font-size: 14.5px; font-weight: 700; color: #0f2847; margin-top: 10px; }
						.uji-ttd-nip { font-size: 12px; color: #8a94a6; margin-top: 2px; }

						/* ── Versi cetak resmi (.uji-silang-cetak) ──
						   Dokumen formal hitam-putih, terpisah dari preview berwarna
						   di layar - dipakai saat window.print() (lihat handlePrint).
						   Kertas F4 (215x330mm) - SAMA dengan ukuran .kertas-laporan
						   (210x330mm) yang dipakai semua laporan print lain di aplikasi
						   ini (lihat laporan.css). @page WAJIB disamakan persis, kalau
						   tidak (mis. dipaksa A4/297mm) kontennya meluber ke halaman ke-2
						   (lihat diskusi 2026-10-07). */
						@media print {
							@page { size: 215mm 330mm; margin: 10mm 12mm 2mm 12mm; }
						}
						/* Footer ditempel ke dasar halaman pakai flex + margin-top:auto
						   (bukan position:absolute) - absolute terhadap parent yang
						   cuma punya min-height (tanpa height pasti) tidak konsisten
						   di berbagai print engine, hasilnya footer nempel ke konten
						   bukan ke dasar kertas (lihat laporan 2026-10-07). min-height
						   (bukan height) dipakai supaya tidak memaksa box melebihi
						   area cetak F4 (330mm dikurangi margin @page 2x8mm) yang bisa
						   meluber ke halaman ke-2. */
						/* width: auto (bukan width: 210mm bawaan .kertas-laporan global
						   di laporan.css) - 210mm LEBIH LEBAR dari area cetak F4 kita
						   (215mm - 2x10mm margin @page = 195mm), jadi kontennya meluber
						   15mm ke kanan dan garis kolom paling kanan (Keterangan)
						   terpotong di luar kertas, baik di preview maupun hasil cetak
						   fisik (lihat laporan 2026-10-09). auto membuatnya pas mengisi
						   penuh area cetak F4, berapa pun margin @page-nya. */
						.uji-silang-cetak.kertas-laporan {
							width: auto; height: auto; min-height: 300mm; padding: 0;
							display: flex; flex-direction: column;
						}
						.uji-silang-cetak { font-family: 'Times New Roman', Times, serif; color: #000; }
						.uji-silang-cetak .cetak-kop {
							text-align: center;
							border-bottom: 2px solid #000;
							padding-bottom: 6px;
							margin-bottom: 10px;
						}
						.uji-silang-cetak .cetak-kop-instansi {
							font-size: 14px; font-weight: 700; letter-spacing: .4px; text-transform: uppercase;
						}
						.uji-silang-cetak .cetak-kop-wilayah {
							font-size: 12px; margin-top: 1px;
						}
						.uji-silang-cetak .cetak-judul {
							text-align: center; margin-bottom: 10px;
						}
						.uji-silang-cetak .cetak-judul-utama {
							font-size: 13.5px; font-weight: 700; text-decoration: underline; text-underline-offset: 3px;
						}
						.uji-silang-cetak .cetak-judul-sub { font-size: 12px; margin-top: 2px; }
						.uji-silang-cetak table.laporan-table {
							width: 100%; max-width: 100%; table-layout: auto;
							border-collapse: collapse; font-size: 11px;
							border: 1px solid #000; box-sizing: border-box;
						}
						.uji-silang-cetak table.laporan-table th,
						.uji-silang-cetak table.laporan-table td {
							border: 1px solid #000; padding: 3px 7px;
							box-sizing: border-box;
						}
						/* Timpa border-top/bottom bawaan .laporan-table (thead/tbody) di
						   laporan.css global ("double 5px"/"solid 3px") - kelas itu masih
						   ikut nempel di tabel ini, bikin sebagian garis lebih tebal/dobel
						   dibanding garis lain yang cuma 1px dari aturan th/td di atas
						   (lihat laporan 2026-10-09). Semua garis WAJIB seragam 1px solid.
						*/
						.uji-silang-cetak table.laporan-table thead,
						.uji-silang-cetak table.laporan-table tbody {
							border: none;
						}
						.uji-silang-cetak table.laporan-table thead th {
							background: #e9edf3; font-weight: 700; text-transform: uppercase; font-size: 10.5px;
						}
						.uji-silang-cetak .cetak-ttd-blok { margin-top: 16px; font-size: 12px; }
						.uji-silang-cetak .cetak-ttd-tempat { text-align: right; margin-bottom: 4px; }
						.uji-silang-cetak .cetak-ttd-jabatan { font-weight: 600; }
						.uji-silang-cetak .cetak-ttd-nama { margin-top: 36px; font-weight: 700; text-decoration: underline; text-underline-offset: 3px; }
						.uji-silang-cetak .cetak-ttd-nip { margin-top: 2px; }
						/* FIX: position:fixed (percobaan sebelumnya) ternyata bikin footer
						   HILANG TOTAL saat print/PDF - bug lama Chromium, elemen
						   position:fixed kadang tidak ikut dirender ke output cetak/PDF
						   sama sekali (lihat laporan 2026-10-09). Dibalikkan ke flex +
						   margin-top:auto, lebih bisa diandalkan meski presisi "mentok"-nya
						   bergantung pada min-height .kertas-laporan di atas. */
						.uji-silang-cetak .cetak-footer {
							margin-top: auto; padding-top: 16px;
							font-size: 9.5px; color: #555; text-align: left; font-family: Arial, sans-serif;
						}
					`}</style>
				</Helmet>

				<Card className="uji-silang-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden', marginBottom: 16 }} bodyStyle={{ padding: 0 }}>

					{/* Header */}
					<div style={{ padding: '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<SyncOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Uji silang data penerimaan SWDKLLJ antara Jasa Raharja dan Bendahara SAMSAT
							</div>
						</div>
						{data && !isEmpty && (
							<Tooltip title="Cetak laporan">
								<Button icon={<PrinterOutlined />} onClick={this.handlePrint} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}>
									{!isMobile && 'Cetak'}
								</Button>
							</Tooltip>
						)}
					</div>

					{/* Filter */}
					<div style={{ padding: '16px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
						<Form ref={this.formRef} layout="vertical" onFinish={this.handleSubmit}>
							<Row gutter={[12, 0]} align="bottom">
								<Col xs={24} sm={14} md={8} lg={5}>
									<Form.Item label="Kabupaten / Kota" style={{ marginBottom: 0 }}>
										<Select
											showSearch
											optionFilterProp="children"
											loading={loadingKabupaten}
											disabled={kabupatenLocked}
											placeholder="Pilih Kabupaten / Kota"
											style={{ width: '100%' }}
											value={filterKabupaten}
											onChange={(val) => {
												this.setState({ filterKabupaten: val, filterUpt: undefined });
												this.getListUpt(val);
											}}
										>
											{listKabupaten.map((k) => (
												<Select.Option key={k.id} value={k.id}>{k.name}</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>
								<Col xs={24} sm={10} md={8} lg={5}>
									<Form.Item label="UPT" style={{ marginBottom: 0 }}>
										<Select
											showSearch
											optionFilterProp="children"
											loading={loadingUpt}
											disabled={kabupatenLocked ? listUpt.length <= 1 : !filterKabupaten}
											placeholder="Pilih UPT"
											style={{ width: '100%' }}
											value={filterUpt}
											onChange={(val) => this.setState({ filterUpt: val })}
										>
											{listUpt.map((u) => (
												<Select.Option key={u.id} value={u.id}>{u.nama}</Select.Option>
											))}
										</Select>
									</Form.Item>
								</Col>
								<Col xs={24} sm={10} md={8} lg={6}>
									<Form.Item label="Bulan / Periode" style={{ marginBottom: 0 }}>
										<MonthPicker
											placeholder="mm-yyyy"
											format="MM-YYYY"
											style={{ width: '100%', borderRadius: 8 }}
											value={filterBulan}
											disabledDate={(current) => current && current > moment().endOf('month')}
											onChange={(date) => this.setState({ filterBulan: date })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8} lg={8}>
									<Form.Item style={{ marginBottom: 0 }}>
										<div style={{ display: 'flex', gap: 8, marginTop: isMobile ? 8 : 0 }}>
											<Button
												type="primary" icon={<SearchOutlined />} htmlType="submit"
												loading={loading} disabled={loading || belumLengkap}
												style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', borderRadius: 8, fontWeight: 600 }}>
												Proses
											</Button>
											{data && !isEmpty && (
												<Button icon={<PrinterOutlined />} onClick={this.handlePrint} style={{ borderRadius: 8 }}>
													Cetak
												</Button>
											)}
										</div>
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>
				</Card>

				{/* Konten laporan */}
				<Card style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'auto' }}>
					{loading && (
						<div style={{ textAlign: 'center', padding: '40px 0', color: '#1e4d8a', fontSize: 16 }}>
							<RedoOutlined spin style={{ marginRight: 10, fontSize: 18 }} />
							Memproses laporan...
						</div>
					)}

					{err && !loading && (
						<div style={{ textAlign: 'center', padding: '40px 0', color: '#cf1322', fontSize: 14 }}>
							Gagal memuat laporan. Coba pilih bulan dan tekan Proses kembali.
						</div>
					)}

					{!data && !loading && !err && (
						<div style={{ textAlign: 'center', padding: '40px 0', color: '#aaa', fontSize: 14 }}>
							Pilih bulan dan tekan <b>Proses</b> untuk menampilkan laporan
						</div>
					)}

					{data && isEmpty && !loading && (
						<div style={{ textAlign: 'center', padding: '40px 0', color: '#aaa', fontSize: 14 }}>
							Data tidak ditemukan untuk periode dan UPT yang dipilih.
						</div>
					)}

					{data && !isEmpty && (() => {
						const items      = data.data.items || [];
						const adaData    = items.filter((it) => it.total_unit > 0);
						const totalUnit  = adaData.reduce((acc, it) => acc + (it.total_unit || 0), 0);
						const fmtRp      = (v) => 'Rp ' + Number(v || 0).toLocaleString('id');

						const columns = [
							{
								title: 'Tanggal', dataIndex: 'tanggal', key: 'tanggal', width: 160,
								render: (v) => moment(v).format('DD MMMM YYYY'),
							},
							{
								title: 'Unit', dataIndex: 'total_unit', key: 'total_unit', width: 90, align: 'right',
								render: (v) => v.toLocaleString('id'),
							},
							{
								title: 'Jasa Raharja', dataIndex: 'total_pokok_swdkllj', key: 'jr', width: 200, align: 'right',
								render: () => '',
							},
							{
								title: 'Bendahara Samsat', dataIndex: 'total_pokok_swdkllj', key: 'bendahara', width: 200, align: 'right',
								render: fmtRp,
							},
						];

						return (
							<>
								{/* Preview modern - tampil di layar */}
								<div>
									<div style={{ marginBottom: 16 }}>
										<div style={{ fontWeight: 700, fontSize: 16, color: '#0f2847' }}>
											Data Penerimaan SWDKLLJ — SAMSAT {data.summary.nama_samsat}
										</div>
										<div style={{ fontSize: 13, color: '#8a94a6', marginTop: 2 }}>
											Periode Bulan {data.summary.periode}
										</div>
									</div>

									<Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
										<Col xs={12} md={6}>
											<div className="uji-stat-card">
												<div className="uji-stat-icon" style={{ background: 'linear-gradient(135deg, #0f2847, #1e4d8a)' }}>
													<WalletOutlined />
												</div>
												<div>
													<div className="uji-stat-label">Total SWDKLLJ</div>
													<div className="uji-stat-value">{fmtRp(data.summary.total_sw)}</div>
												</div>
											</div>
										</Col>
										<Col xs={12} md={6}>
											<div className="uji-stat-card">
												<div className="uji-stat-icon" style={{ background: 'linear-gradient(135deg, #0d9488, #14b8a6)' }}>
													<CarOutlined />
												</div>
												<div>
													<div className="uji-stat-label">Jumlah Unit</div>
													<div className="uji-stat-value">{totalUnit.toLocaleString('id')}</div>
												</div>
											</div>
										</Col>
										<Col xs={12} md={6}>
											<div className="uji-stat-card">
												<div className="uji-stat-icon" style={{ background: 'linear-gradient(135deg, #b45309, #d97706)' }}>
													<CalendarOutlined />
												</div>
												<div>
													<div className="uji-stat-label">Hari Ada Transaksi</div>
													<div className="uji-stat-value">{adaData.length} Hari</div>
												</div>
											</div>
										</Col>
										<Col xs={12} md={6}>
											<div className="uji-stat-card">
												<div className="uji-stat-icon" style={{ background: 'linear-gradient(135deg, #4338ca, #6366f1)' }}>
													<FileTextOutlined />
												</div>
												<div>
													<div className="uji-stat-label">Periode</div>
													<div className="uji-stat-value" style={{ fontSize: 14 }}>{data.summary.periode}</div>
												</div>
											</div>
										</Col>
									</Row>

									{adaData.length === 0 ? (
										<Empty description="Tidak ada tanggal dengan transaksi pada periode ini" style={{ padding: '24px 0' }} />
									) : isMobile ? (
										<div>
											{adaData.map((item, i) => (
												<div className="uji-mobile-row" key={i}>
													<div>
														<div style={{ fontWeight: 600, color: '#0f2847', fontSize: 13.5 }}>
															{moment(item.tanggal).format('DD MMMM YYYY')}
														</div>
														<div style={{ fontSize: 11.5, color: '#8a94a6', marginTop: 2 }}>
															{item.total_unit} unit
														</div>
													</div>
													<div style={{ textAlign: 'right' }}>
														<div style={{ fontWeight: 700, color: '#0f2847', fontSize: 13.5 }}>
															{fmtRp(item.total_pokok_swdkllj)}
														</div>
													</div>
												</div>
											))}
										</div>
									) : (
										<Table
											className="uji-preview-table"
											columns={columns}
											dataSource={adaData.map((it, i) => ({ ...it, key: i }))}
											pagination={false}
											size="middle"
											scroll={{ x: 560 }}
											bordered
											summary={() => (
												<Table.Summary.Row>
													<Table.Summary.Cell index={0}><b>Jumlah</b></Table.Summary.Cell>
													<Table.Summary.Cell index={1} align="right"><b>{totalUnit.toLocaleString('id')}</b></Table.Summary.Cell>
													<Table.Summary.Cell index={2} align="right"></Table.Summary.Cell>
													<Table.Summary.Cell index={3} align="right"><b>{fmtRp(data.summary.total_sw)}</b></Table.Summary.Cell>
												</Table.Summary.Row>
											)}
										/>
									)}

									<div style={{ fontSize: 11.5, color: '#aaa', marginTop: 8 }}>
										Preview hanya menampilkan tanggal dengan transaksi. Versi cetak PDF menampilkan seluruh tanggal dalam periode.
									</div>

									{data.ttd && (
										<Row gutter={[12, 12]} style={{ marginTop: 24 }}>
											<Col xs={24} style={{ textAlign: 'right', fontSize: 13, color: '#8a94a6', marginBottom: 4 }}>
												{data.summary.nama_upt}, {data.summary.tanggal}
											</Col>
											<Col xs={24} sm={8}>
												<div className="uji-ttd-card">
													<TeamOutlined style={{ fontSize: 20, color: '#1e4d8a', marginBottom: 8 }} />
													<div className="uji-ttd-jabatan">{data.ttd.kiri.jabatan}</div>
													<div className="uji-ttd-nama">{data.ttd.kiri.nama}</div>
													<div className="uji-ttd-nip">NIP : {data.ttd.kiri.nip}</div>
												</div>
											</Col>
											<Col xs={24} sm={8}>
												<div className="uji-ttd-card">
													<TeamOutlined style={{ fontSize: 20, color: '#1e4d8a', marginBottom: 8 }} />
													<div className="uji-ttd-jabatan">{data.ttd.tengah.jabatan}</div>
													<div className="uji-ttd-nama">{data.ttd.tengah.nama}</div>
													<div className="uji-ttd-nip">NIP : {data.ttd.tengah.nip}</div>
												</div>
											</Col>
											<Col xs={24} sm={8}>
												<div className="uji-ttd-card">
													<TeamOutlined style={{ fontSize: 20, color: '#1e4d8a', marginBottom: 8 }} />
													<div className="uji-ttd-jabatan">{data.ttd.kanan.jabatan}</div>
													<div className="uji-ttd-nama">{data.ttd.kanan.nama}</div>
													<div className="uji-ttd-nip">NPP : {data.ttd.kanan.nip}</div>
												</div>
											</Col>
										</Row>
									)}
								</div>

								{/* Versi cetak - persis format dokumen resmi, disembunyikan di layar,
								    ditampilkan sesaat oleh handlePrint() saat window.print() (lihat
								    pola yang sama di LapBaBatalSkpd.jsx, diskusi 2026-10-07) */}
								<div className="kertas-laporan uji-silang-cetak" style={{ display: 'none' }}>
									<div className="cetak-kop">
										<div className="cetak-kop-instansi">PT. Jasa Raharja (Persero)</div>
										<div className="cetak-kop-wilayah">Kantor Wilayah Kalimantan Tengah</div>
									</div>
									<div className="cetak-judul">
										<div className="cetak-judul-utama">DATA PENERIMAAN SWDKLLJ</div>
										<div className="cetak-judul-sub">
											SAMSAT {data.summary.nama_samsat} &middot; Periode Bulan {data.summary.periode}
										</div>
									</div>
									<table className="laporan-table">
										<thead>
											<tr>
												<th rowSpan="2">Tanggal</th>
												<th colSpan="2">Hasil Penerimaan SWDKLLJ</th>
												<th rowSpan="2">Keterangan</th>
											</tr>
											<tr>
												<th>Jasa Raharja</th>
												<th>Bendahara Samsat</th>
											</tr>
										</thead>
										<tbody>
											{items.map((item, i) => (
												<tr key={i}>
													<td className="teks-tengah">{moment(item.tanggal).format('DD')}</td>
													<td className="teks-kanan">&nbsp;</td>
													<td className="teks-kanan">{(item.total_pokok_swdkllj).toLocaleString('id')}</td>
													<td className="teks-tengah">&nbsp;</td>
												</tr>
											))}
											<tr>
												<td className="teks-tengah"><b>JUMLAH</b></td>
												<td className="teks-kanan">&nbsp;</td>
												<td className="teks-kanan"><b>{(data.summary.total_sw).toLocaleString('id')}</b></td>
												<td className="teks-tengah">&nbsp;</td>
											</tr>
										</tbody>
									</table>
									{data.ttd && (
										<div className="cetak-ttd-blok">
											<div className="cetak-ttd-tempat">{data.summary.nama_upt}, {data.summary.tanggal}</div>
											<Row justify="space-between">
												<Col span={8} className="teks-tengah">
													<div className="cetak-ttd-jabatan">{data.ttd.kiri.jabatan}</div>
													<div className="cetak-ttd-nama">{data.ttd.kiri.nama}</div>
													<div className="cetak-ttd-nip">NIP : {data.ttd.kiri.nip}</div>
												</Col>
												<Col span={8} className="teks-tengah">
													<div className="cetak-ttd-jabatan">{data.ttd.tengah.jabatan}</div>
													<div className="cetak-ttd-nama">{data.ttd.tengah.nama}</div>
													<div className="cetak-ttd-nip">NIP : {data.ttd.tengah.nip}</div>
												</Col>
												<Col span={8} className="teks-tengah">
													<div className="cetak-ttd-jabatan">{data.ttd.kanan.jabatan}</div>
													<div className="cetak-ttd-nama">{data.ttd.kanan.nama}</div>
													<div className="cetak-ttd-nip">NPP : {data.ttd.kanan.nip}</div>
												</Col>
											</Row>
										</div>
									)}
									<div className="cetak-footer">
										Dicetak otomatis melalui Sistem e-SAMSAT &middot; {moment().format('DD-MM-YYYY HH:mm')}
									</div>
								</div>
							</>
						);
					})()}
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler, ajaxDownloadHandler })(UjiSilangSWD);
